import React from 'react';
import { Box, Typography, Grid, Paper } from '@mui/material';

const Recommendations = ({ city, recommendations, intensityColor }) => {
    if (!recommendations.length) return null;

    return (
        <Box sx={{ mt: 6, p: 3, backgroundColor: '#1a1a1a', borderRadius: 2 }}>
            <Typography variant="h6" sx={{ color: '#fff', mb: 1 }}>AI-Based Session Recommendations</Typography>
            <Typography sx={{ color: '#ccc', mb: 2 }}>
                Based on <strong>{city}</strong>'s aggregated preferences, we suggest the following high-demand time slots for organizing sessions:
            </Typography>
            <Grid container spacing={2}>
                {recommendations.map(([key, count]) => {
                    const [day, label] = key.split('-');
                    return (
                        <Grid item xs={12} sm={6} md={4} key={key}>
                            <Paper sx={{ backgroundColor: '#222', p: 2, borderLeft: `4px solid ${intensityColor(count)}` }}>
                                <Typography variant="subtitle2" sx={{ color: '#fff' }}>{`${label} on ${day}`}</Typography>
                                <Typography variant="body2" sx={{ color: '#aaa' }}>{`${count} overlapping preferences`}</Typography>
                            </Paper>
                        </Grid>
                    );
                })}
            </Grid>
        </Box>
    );
};

export default Recommendations;
